var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIotHiveLevel1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.464,
    height: 35.874,
    viewBox: "0 0 38.464 35.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.757 0.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.395,503.941h28.84a.9.9,0,0,1,.86.635l3.257,10.574a.9.9,0,0,1-.86,1.165H86.343a.9.9,0,0,1-.864-1.149l3.051-10.575A.9.9,0,0,1,89.395,503.941Z",
    transform: "translate(-85.443 -492.941)",
    fill: "#ffde3b",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.395,503.941h28.84a.9.9,0,0,1,.86.635l3.257,10.574a.9.9,0,0,1-.86,1.165H86.343a.9.9,0,0,1-.864-1.149l3.051-10.575A.9.9,0,0,1,89.395,503.941Z",
    transform: "translate(-85.443 -503.941)",
    fill: "#fff",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.395,503.941h28.84a.9.9,0,0,1,.86.635l3.257,10.574a.9.9,0,0,1-.86,1.165H86.343a.9.9,0,0,1-.864-1.149l3.051-10.575A.9.9,0,0,1,89.395,503.941Z",
    transform: "translate(-85.443 -503.941)",
    fill: "#fff",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotHiveLevel1);
export default __webpack_public_path__ + "static/media/iotHiveLevel1.c804c0f1935e3b66c971f282ba4e8d73.svg";
export { ForwardRef as ReactComponent };